// extracted by mini-css-extract-plugin
export var cardTitle = "_iz-1";
export var commentBubble = "_iz-e";
export var commentForm = "_iz-a";
export var commentInput = "_iz-b";
export var commentLabel = "_iz-d";
export var commentPrompt = "_iz-9";
export var csatCard = "_iz-0";
export var feedbackSection = "_iz-7";
export var starDisabled = "_iz-6";
export var starEmpty = "_iz-5";
export var starFilled = "_iz-4";
export var starWrapper = "_iz-3";
export var starsContainer = "_iz-2";
export var submittedComment = "_iz-c";
export var thankYouText = "_iz-8";